export const colors = {
  all: { name: 'Todos', hex: null },
  terra: { name: 'Terra', hex: '#55514dff' },
  capri: { name: 'Capri', hex: '#4a92a4ff' },
  nuit: { name: 'Nuit', hex: '#242424ff' },
  rosa: { name: 'Rosa', hex: '#e799b1ff' },
};
